import { writable } from 'svelte/store';

export const isPopupBuyOpened = writable(false);
export const isPopupLvlOpened = writable(false);
export const isPopupInfoOpened = writable(false);